import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-50">
      <div className="space-y-8 mx-auto" data-id="element-51">
        <p className="text-muted text-sm font-bold tracking-widest uppercase" data-id="element-52">
          Melbourne, Australia • Since 2011
        </p>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-semibold text-text leading-tight max-w-4xl mx-auto" data-id="element-53">
          eCommerce experts since 2011.
        </h1>

        <p className="text-xl md:text-2xl text-muted max-w-2xl mx-auto font-light" data-id="element-54">
          Agency services and software from a team that's seen it all.
        </p>

        <div className="max-w-2xl mx-auto py-8" data-id="element-55">
          <div className="bg-surface border-l-4 border-l-primary rounded shadow-warm p-6 text-left space-y-4" data-id="element-56">
            <h2 className="text-sm font-bold tracking-widest uppercase text-muted" data-id="element-57">
              Our Story
            </h2>
            <p className="text-text leading-relaxed" data-id="element-58">
              CRU started by building one of Australia's first true
              choose-your-own wine club platforms—that level of flexibility
              didn't exist yet. For years we ran both the agency and our own
              software, powering wine clubs across the country. The innovation
              in other ecosystems became too hard to ignore. We made a
              deliberate shift—helping clients future-proof their stack while
              doubling down on what we do best: building. Today, CRU is the
              parent company for two divisions. Modern Commerce is our agency,
              specialising in Shopify, Commerce7, and wine DTC platforms. The
              Apps Division builds practical tools for gaps we see in the
              ecosystems we work in every day. Same instinct to build. New
              structure to do it properly.
            </p>
            <Link to="/about" className="inline-flex items-center text-primary font-semibold hover:opacity-80 transition-opacity" data-id="element-59">
              Learn more <span className="ml-1" data-id="element-60">→</span>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 max-w-[calc(100%-0px)] mx-auto" data-id="element-61">
          <div className="flex justify-center md:justify-end" data-id="element-62">
            <Link to="/modern-commerce" data-id="element-63">
              <Button size="lg" data-id="element-64">Modern Commerce</Button>
            </Link>
          </div>
          <div className="flex justify-center md:justify-start" data-id="element-65">
            <Link to="/apps-division" data-id="element-66">
              <Button variant="outline" size="lg" data-id="element-67">
                Apps Division
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}